module.exports = __webpack_public_path__ + "assets/img/hot.4f712ab7.png";